import React from 'react';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import { Text } from 'common-components/typography';
import { ActivityGroupModalType } from 'utilities/enum-utils';
import { openModalFuncType } from '../SessionActivityGroupsPanel';

interface IEmptyStateProps {
  openModal: openModalFuncType;
}

function EmptyState(props: IEmptyStateProps) {
  const { openModal } = props;

  return (
    <>
      <div className="flex-row justify-between align-center mb-x-small">
        <div className="line-height-120">
          <Text weight="bold">Activity group templates</Text> <br />
          <Text>Create activity groups for this service to use in group sessions.</Text>
        </div>
      </div>

      <div
        className="bg-tertiary mt-large rounded flex justify-center align-center text-align-center"
        style={{ height: '400px' }}
      >
        <div>
          <Text>Create activity group</Text>
          <br />
          <Text color="secondary">A group easily allow you to manage activities during the session.</Text>
          <br />
          <PrimaryButton
            className="mt-medium"
            size="large"
            icon={'plus'}
            onClick={() => openModal(null, ActivityGroupModalType.CREATE)}
          >
            {' '}
            Create activity group
          </PrimaryButton>
        </div>
      </div>
    </>
  );
}

export default EmptyState;
